package com.eladfinish.bible.contest.ui.components.loaders

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.progressSemantics
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.ui.common.accentColor
import com.eladfinish.bible.contest.ui.common.blueGradient

@Composable
fun CircularLoader(
    modifier: Modifier = Modifier,
    strokeWidth: Dp = 6.dp,
) {
    val animation = rememberInfiniteTransition()
    val angle = animation.animateFloat(
        initialValue = 0f,
        targetValue = 360f,
        animationSpec = infiniteRepeatable(
            animation = tween(
                durationMillis = 1000,
                easing = LinearEasing
            ),
            repeatMode = RepeatMode.Restart
        )
    )

    ArcWithGradient(
        modifier = modifier.rotate(angle.value),
        strokeWidth = strokeWidth
    )
}

@Composable
private fun ArcWithGradient(modifier: Modifier, strokeWidth: Dp) {
    val stroke = with(LocalDensity.current) {
        Stroke(
            width = strokeWidth.toPx(),
            cap = StrokeCap.Round
        )
    }

    Canvas(
        modifier = modifier
            .padding(strokeWidth / 2)
            .progressSemantics()
    ) {
        drawArc(
            startAngle = 0f,
            sweepAngle = 300f,
            useCenter = false,
            brush = Brush.sweepGradient(
                0f to accentColor.copy(alpha = 0f),
                0.9f to accentColor.copy(alpha = 1f),
                0.95f to accentColor.copy(alpha = 0f),
                1f to accentColor.copy(alpha = 0f)
            ),
            style = stroke
        )
    }
}

@Preview
@Composable
fun CircularLoaderPreview() {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(brush = blueGradient)
            .padding(10.dp)
    ) {
        CircularLoader(modifier = Modifier.size(40.dp), strokeWidth = 6.dp)
        Spacer(modifier = Modifier.height(20.dp))
        CircularLoader(modifier = Modifier.size(60.dp), strokeWidth = 8.dp)
    }
}
